import {
  getOrderCartList, //购物车列表
  getClothDictList,//品类列表
  getOrderSearch,//获得搜索项字典
  getOrderCustomerById,//订单客户信息
  updateOrderCustomerById,//编辑更新客户
  getCartOrderDetail,//获取购物车订单详情
  updateOrder,//删除订单
  updateOrderAddproduct,//追加西裤
  updateCartOrderAmount,//修改购物车订单数量
  getOrderSumPrice,//计算购物车价格
  pushOrder,//提交订单
  getLabelList,//标签列表
  saveOrderLabel,//保存标签
  saveOrderLabels,//关联标签
  deleteLabel,//关联标签
  canceMtmOrder,//撤销订单
  submitOrder,//直接提交到订单
  editOrder,//编辑
  getRecommendClothList,//购物车推荐
  getOrderCodeList,//订单号列表
  pushOrderCost,//提交单耗
  getOrderCostDetail,//单耗详情
  getOrderFormula,//计价公式
  preCommit,//预提交
  selectDictBasicTree, //左侧列表
  goodsList, //产品列表
  goodsListStyle, //产品列表2
  goodsDetail, //产品详情
  submit,//提交
  submitStyle,//提交2
  categoryList,//分类
  categoryListStyle,//分类2
  goodsDetailStyle,//详情
  saveToCart, //加入购物车
} from "@/api/cart.js";

export default {
  state: {},
  actions: {
    // 提交
    submitStyleAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        submitStyle(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 详情
    goodsDetailStyleAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        goodsDetailStyle(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 分类2
    categoryListStyleAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        categoryListStyle(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 分类
    categoryListAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        categoryList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 产品提交
    submitAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        submit(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 产品详情
    goodsDetailAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        goodsDetail(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 产品列表
    goodsListAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        goodsList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 产品列表2
    goodsListStyleAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        goodsListStyle(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 左侧列表
    selectDictBasicTreeAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        selectDictBasicTree(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 购物车列表
    getOrderCartListAction({
                             commit
                           }, params) {
      return new Promise((resolve, reject) => {
        getOrderCartList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 计价公式
    getOrderFormulaAction({
                            commit
                          }, params) {
      return new Promise((resolve, reject) => {
        getOrderFormula(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 单耗详情
    getOrderCostDetailAction({
                               commit
                             }, params) {
      return new Promise((resolve, reject) => {
        getOrderCostDetail(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 提交单耗
    pushOrderCostAction({
                          commit
                        }, params) {
      return new Promise((resolve, reject) => {
        pushOrderCost(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 订单号列表
    getOrderCodeListAction({
                             commit
                           }, params) {


      return new Promise((resolve, reject) => {
        getOrderCodeList(params)
          .then(res => {
            resolve(res.data?res.data:undefined);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 购物车推荐
    getRecommendClothListAction({
                                  commit
                                }, params) {
      return new Promise((resolve, reject) => {
        getRecommendClothList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 编辑订单
    editOrderAction({
                      commit
                    }, params) {
      return new Promise((resolve, reject) => {
        editOrder(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 直接提交到订单
    submitOrderAction({
                        commit
                      }, params) {
      return new Promise((resolve, reject) => {
        submitOrder(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 购物车列表
    getOrderCartListAction({
                             commit
                           }, params) {
      return new Promise((resolve, reject) => {
        getOrderCartList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 撤销订单
    canceMtmOrderAction({
                          commit
                        }, params) {
      return new Promise((resolve, reject) => {
        canceMtmOrder(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 关联标签
    saveOrderLabelsAction({
                            commit
                          }, params) {
      return new Promise((resolve, reject) => {
        saveOrderLabels(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 关联标签
    deleteLabelAction({
                        commit
                      }, params) {
      return new Promise((resolve, reject) => {
        deleteLabel(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 保存标签
    saveOrderLabelAction({
                           commit
                         }, params) {
      return new Promise((resolve, reject) => {
        saveOrderLabel(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 标签列表
    getLabelListAction({
                         commit
                       }, params) {
      return new Promise((resolve, reject) => {
        getLabelList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 提交订单
    pushOrderAction({
                      commit
                    }, params) {
      return new Promise((resolve, reject) => {
        pushOrder(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 修改购物车数量
    updateCartOrderAmountAction({
                                  commit
                                }, params) {
      return new Promise((resolve, reject) => {
        updateCartOrderAmount(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 计算购物车价格
    getOrderSumPriceAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getOrderSumPrice(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 追加西裤
    updateOrderAddproductAction({
                                  commit
                                }, params) {
      return new Promise((resolve, reject) => {
        updateOrderAddproduct(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 删除订单
    updateOrderAction({
                        commit
                      }, params) {
      return new Promise((resolve, reject) => {
        updateOrder(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 购物车详情
    getCartOrderDetailAction({
                               commit
                             }, params) {
      return new Promise((resolve, reject) => {
        getCartOrderDetail(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 订单的客户信息
    getOrderCustomerByIdAction({
                                 commit
                               }, params) {
      return new Promise((resolve, reject) => {
        getOrderCustomerById(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 编辑客户信息
    updateOrderCustomerByIdAction({
                                    commit
                                  }, params) {
      return new Promise((resolve, reject) => {
        updateOrderCustomerById(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 搜索项字典
    getOrderSearchAction({
                           commit
                         }, params) {
      return new Promise((resolve, reject) => {
        getOrderSearch(params)
          .then(res => {
            if (undefined !== res) {
              resolve(res.data);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 品类列表
    getClothDictListAction({
                             commit
                           }, params) {
      return new Promise((resolve, reject) => {
        getClothDictList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 计价公式
    preCommitAction({commit}, params) {
      return new Promise((resolve, reject) => {
        preCommit(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 加入购物车
    saveToCartAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        saveToCart(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
  }, mutations: {}, getters: {}
};



// WEBPACK FOOTER //
// ./src/store/module/cart.js